import { ModalBody as ChakraModalBody } from "@chakra-ui/react";

export const ModalBody = ChakraModalBody;
